var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip",class:_vm.variant,on:{"mouseover":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_c('span',{staticClass:"tooltip-btn info-block"}),(_vm.show)?_c('div',{staticClass:"tooltip-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }